import { Children, cloneElement, createElement } from 'react';

const Row = ({ children, className = "", style = {}, noClone = false, source = undefined, ...props }) => createElement("div", { className: `row ${className}`, style }, Children.map(children, (child) => noClone ? child : cloneElement(child, props)));

Row.displayName = 'Row';

export default Row;